import {hal_http} from '../support/http';

export default {
  async print(receipt) {
    return (await hal_http().post(`/printer/print-totem`, receipt)).data;
  },
};


